export const lssLangEs = {
  contact: {
    contactList: 'Lista de contactos',
    callLog: 'Llamadas',
    name: 'Nombre',
    phone: 'Teléfono',
    close: 'Cerca',  
    check: 'Controlar',
    searchName: 'Nombre de búsqueda',
    lastDialTime: 'Hora de la última llamada ',
    numberOfCalls: 'number of calls'
  },
};
